import styled from 'styled-components';
import { StyledCallPane } from '../CallPane/CallPane.styles';
import { StyledHeader } from '../EventPane/EventPaneHeader';

export const PANE_WIDTH = 480;

export const AirAmbulanceStandAlonePane = styled(StyledCallPane)`
  width: ${PANE_WIDTH}px;
  overflow-y: scroll; /* Enable scrolling */

  /* Hide scrollbar for Chrome, Safari, and Edge */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;

export const AirAmbulanceStandAlonePaneStyledHeader = styled(
  StyledHeader,
).attrs({
  margin: 0,
})``;
